import React from 'react';
import { useTranslation } from 'react-i18next';
import { SAPContact } from '../../types';
import { FormattedPhone } from '../common/FormattedPhone';
import { SapContactActions } from './SapContactActions';
import { getSapContactDisplayName } from './sap-contact.types';
import styles from './SapContact.module.css';

interface SapContactCardProps {
  contact: SAPContact;
  callerNumber?: string | null;
  linkedSapContactId?: string | null;
  showActions: boolean;
  onLink: (contact: SAPContact) => void;
}

export function SapContactCard({
  contact,
  callerNumber,
  linkedSapContactId = null,
  showActions,
  onLink,
}: SapContactCardProps) {
  const { t } = useTranslation();
  const isLinked = linkedSapContactId === contact.id;

  return (
    <div className={styles.sapContactCard}>
      <div className={styles.sapContactAvatar}>
        {contact.type === 'corporate' ? (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
          </svg>
        )}
      </div>
      <div className={styles.sapContactInfo}>
        <div className={styles.sapContactName}>
          {getSapContactDisplayName(contact, t)}
          {isLinked && <span className={styles.sapLinkedBadge}>{t('call:sap.linkedToCall')}</span>}
        </div>
        {contact.email && <div className={styles.sapContactDetail}>{contact.email}</div>}
        {contact.phone && (
          <div className={styles.sapContactDetail}>
            <FormattedPhone value={contact.phone} />
          </div>
        )}
        {contact.extensions && Object.keys(contact.extensions).length > 0 && (
          <div className={styles.sapContactDetail}>
            {Object.entries(contact.extensions).map(([key, value]) => (
              <span key={key}>
                {key}: {value}
              </span>
            ))}
          </div>
        )}
        {contact.accountName && contact.type === 'individual' && (
          <div className={styles.sapContactDetail}>{contact.accountName}</div>
        )}
      </div>
      {showActions && (
        <SapContactActions
          contact={contact}
          callerNumber={callerNumber}
          linkedContactId={linkedSapContactId}
          onLink={onLink}
        />
      )}
    </div>
  );
}
